<template>

  <div class="row">
    <div class="col-12">
      <h4 class="my-3">템플릿 목록</h4>
    </div>

    <div class="col-md-6"
         v-for="(item,idx) in demos"
         :key="'demo'+idx"
    >
      <div class="card-deck">
        <div class="card mb-4">
          <div style="width: 100%;height: 300px;padding: 10px;position: relative">
            <iframe style="width: 100%;height: 100%" frameborder="0" :src="item.previewUrl">
            </iframe>

            <div
                v-if="!item.hide_layer"
                style="z-index:2;top:0;left:0;width: 100%;height: 100%;position: absolute;background-color: #00000022">
            </div>

          </div>
          <div class="card-body">
            <div class="d-flex">
              <div style="flex:1;padding-right: 5px;" class="d-grid">
                <a @click="preview(item)" class="btn btn-light waves-effect waves-light">새창으로 보기</a>
              </div>
              <div style="flex:1;padding-left: 5px" class="d-grid">
                <a
                    v-if="item.hide_layer"
                    @click="chg_hide_layer(item)" class="btn btn-light waves-effect waves-light">페이지 잠금</a>
                <a
                    v-else
                    @click="chg_hide_layer(item)" class="btn btn-light waves-effect waves-light">페이지 탐색</a>
              </div>
            </div>
            <div style="flex:1;padding-top: 10px">
              <a @click="addDemo(item)" style="width: 100%"  class="btn btn-primary waves-effect waves-light">시작하기</a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {mapGetters} from "vuex";
export default {
  props:{
    embed:{
      type:Boolean,
      default:false
    }
  },
  components:{
  },
  computed:mapGetters({
    login: 'login', // 로그인 상태
    shopid: 'shopid', // 로그인 상태
  }),
  data: () => ({
    demos: [],
  }),
  mounted() {
    this.demo()
  },
  methods:{
    chg_hide_layer:function (item) {
      this.$set(item,'hide_layer',!item.hide_layer)
    },
    preview:function (item) {
      window.open(item.previewUrl)
    },
    addDemo:function(item){

      if(this.login!=1 && this.login!=3) {
        this.$eventBus.$emit('login_confirm')
        return
      }

      const axiosData = {
        demoId: item.demoId
      };

      this.$http
          .post('/api_home/page/demo/v2', axiosData)
          .then(obj=>{
            if(obj.data.success == 1){
              this.$eventBus.$emit('info', '마이샵 홈 만들기','다음 목록에서 추가된 페이지를 편집해주세요.')

              if(!this.embed)
                this.$router.push({path:'/pages'})
              else
                this.$emit('added')
              return
            }

            throw 'err'
          })
          .catch(err=>{
            this.$eventBus.$emit('error', '마이샵 홈 만들기','마이샵 홈 만들기에 실패했습니다.')
          })
    },
    demo:function () {
      this.$http
          .get('/api_home/demos/v2')
          .then(obj=>{
            this.demos = obj.data.demoList;
            this.demos.forEach(el=>{
              this.$set(el,'hide_layer',false)
            })
          })
          .catch(err=>{console.log(err.response.data)})
    },
  }
}
</script>